"use client";
//? Library Imports ------------------------------------------------------------>
import { Col, Row, Radio, Typography } from "antd";
import { useEffect, useCallback, useState } from "react";

import "./ProductOptions.scss";
//? Modules -------------------------------------------------------------------->
import AddonOptions from "../AddonOptions/AddonOptions";
// import SizeChartDrawer from "../../SizeChart/SizeChartDrawer/SizeChartDrawer";
// import NikeTick from '../../../../../assets/Icons/nike-tick-icon.svg'; // Update the path as necessary
import DoneIcon from "@mui/icons-material/Done";
import Cookies from "js-cookie";

//? Library Constants ---------------------------------------------------------->
const { Text } = Typography;

export default function ProductOptions({
  userAgent,
  ProductDetail,
  SelectedVariant,
  setSelectedVariant,
  LineItemAddons,
  setLineItemAddons,
  selectedValueFromOptions,
  setSelectedValueFromOptions,
  handleOptionChange,
  viewBagItemsState,
  setViewBagItemsState,
  pushedVariants,
  setPushedVariants,
  isOutSideProductDetailComponent,
  productSoldout,
  setProductSoldout,
  typeEdit,
  selectSizeError,
  setSelectSizeError,
  availableVariants,
  ProductQuantity,
  setProductQuantity,
  openDrawer,
  setOpenDrawer,
  showDrawer,
  addProduct,
  addToCartLoader,
  setaddToCartLoader,
  handleProductDiscountedPrice,
  handleProductOrignalPrice,
  // isSizeChartOpen,
  // setIsSizeChartOpen,
}) {
  //? Hooks ---------------------------------------------------------------------->
  const { isMobile, isTablet, isDesktop } = userAgent;
  //? States --------------------------------------------------------------------->
  const [disableOptions, setDisableOptions] = useState({});
  const [OtherTempelates, setOtherTempelates] = useState([]);

  // Single Brand Variant Flow

  const [activeSwatches, setActiveSwatches] = useState([]);
  const [soldoutOptionValuesArr, setSoldoutOptionValuesArr] = useState([]);
  const [option1Value, setOption1value] = useState(null);
  const [option2Value, setOption2value] = useState(null);
  const [option3Value, setOption3value] = useState(null);
  const [handleVariantOptions, setHandleVariantOptions] = useState(false);
  const [variantId, setVariantId] = useState(null);
  const [soldout, setSoldout] = useState(false);
  const [sku, setSku] = useState(null);
  const mainColor = Cookies.get("main_theme");
  const secondaryColor = Cookies.get("secondary_theme");
  //? Functions ------------------------------------------------------------------>

  // const changeVariant = (e, index) => {
  //   // console.log(e.target.name);
  //   // console.log(e.target.value);
  //   const selectedName = e.target.name;
  //   const selectedOption = e.target.value;
  //   // console.log(e.target.value);
  //   // console.log(index)
  //   // console.log(ProductDetail?.variants)
  //   // console.log(SelectedVariant);
  //   console.log("ProductDetail:", ProductDetail);

  //   ProductDetail?.options?.forEach((option) => {
  //     debugger
  //     if (option.name === selectedName) {
  //       ProductDetail?.variants?.forEach((variant) => {
  //         debugger
  //         if (
  //           variant["option" + (index + 1)] === selectedOption &&
  //           variant["option" + index] === SelectedVariant["option" + index] &&
  //           index === 1
  //         ) {
  //           setSelectedVariant(variant);
  //           setProductSoldout(variant?.variant_detail?.sold_out);
  //           setSelectSizeError(false);
  //         } else if (
  //           variant["option" + (index + 1)] === selectedOption &&
  //           index === 0
  //         ) {
  //           setSelectedVariant(variant);
  //           setProductSoldout(variant?.variant_detail?.sold_out);
  //           setSelectSizeError(false);
  //         } else if (
  //           variant["option" + (index + 1)] === selectedOption &&
  //           variant["option1"] === SelectedVariant["option1"] &&
  //           variant["option2"] === SelectedVariant["option2"] &&
  //           index === 2
  //         ) {
  //           setSelectedVariant(variant);
  //           setProductSoldout(variant?.variant_detail?.sold_out);
  //           setSelectSizeError(false);
  //         }
  //       });
  //     }
  //   });
  // };

  // const handleChangeValue = (option) => {
  //   let value = { selectedValueFromOptions };
  //   value.option1 = option;
  //   setSelectedValueFromOptions({ ...value });
  // };

  const filterTemplates = useCallback(() => {
    const otherTempelates = ProductDetail?.add_on_templates?.filter(
      (template) => template?.type === "others"
    );
    setOtherTempelates(otherTempelates);
  }, [ProductDetail?.add_on_templates]);

  const handleOptions = () => {
    let concatOptionValues = "";
    if (
      option1Value !== null &&
      option2Value !== null &&
      option3Value !== null &&
      option1Value !== "" &&
      option2Value !== "" &&
      option3Value !== ""
    ) {
      concatOptionValues =
        option1Value + "/" + option2Value + "/" + option3Value;
    } else if (
      option1Value !== null &&
      option2Value !== null &&
      option1Value !== "" &&
      option2Value !== ""
    ) {
      concatOptionValues = option1Value + "/" + option2Value;
    } else if (option1Value !== null && option1Value !== "") {
      concatOptionValues = option1Value;
    }
    handleSelectedVariant(concatOptionValues);
  };
  const handleSelectedVariant = (value) => {
    const variantObj = ProductDetail?.variants?.find((variant) => {
      const options = [variant.option1, variant.option2, variant.option3]
        .filter(Boolean)
        // Trim each non-empty option
        .map(opt => opt.trim())
        .join("/");


      return options?.toLowerCase() === value?.toLowerCase();
    });

    // debugger
    const variantDetailObj = variantObj?.variant_detail;
    if (variantDetailObj && !variantDetailObj?.sold_out) {
      // setSoldout(false);
      setProductSoldout(false);
      // setVariantId(variantDetailObj?.variant_id);
      setSelectedVariant(variantObj);
    } else {
      // setSoldout(true);
      setProductSoldout(true);
      // setVariantId(variantObj?.variant_id);
      setSelectedVariant(variantObj);
    }
    setSku(variantObj?.sku);
    // Sum addons prices if available
    // let defaultDiscountedPrice = removeCommasAndConvertToNumber(
    //   variantDetailObj?.discounted_price
    // );
    // let defaultOrignalPrice = removeCommasAndConvertToNumber(
    //   variantDetailObj?.original_price
    // );
    // defaultDiscountedPrice = defaultDiscountedPrice + addonDiscountedPrice;
    // defaultOrignalPrice = defaultOrignalPrice + addonOrignalPrice;

    // setOrignalPrice(defaultOrignalPrice.toLocaleString());
    // setDiscountedPrice(defaultDiscountedPrice.toLocaleString());
    // setOrignalPrice(variantDetailObj?.original_price);
    // setDiscountedPrice(variantDetailObj?.discounted_price);
  };
  const handleSoldOutOptionValues = () => {
    setSoldoutOptionValuesArr([]);
    ProductDetail?.variants?.forEach((variant) => {
      // if (variant.option1 === option1Value && variant.variant_detail.inventory < 1) {
      //   const valueToAdd = ProductDetail?.options?.length === 1 ? variant.option1 : variant.option2;
      //   setSoldoutOptionValuesArr((prevArr) => [...prevArr, valueToAdd]);
      // }
      if (
        ProductDetail?.options?.length === 1 &&
        variant.variant_detail?.sold_out
      ) {
        let option1value = variant.option1;
        setSoldoutOptionValuesArr((prevArr) => [...prevArr, option1value]);
      } else if (
        ProductDetail?.options?.length === 2 &&
        variant.option1 === option1Value &&
        variant.variant_detail?.sold_out
      ) {
        let option2value = variant.option2;
        setSoldoutOptionValuesArr((prevArr) => [...prevArr, option2value]);
      } else if (
        ProductDetail?.options?.length === 3 &&
        variant.option1 === option1Value &&
        variant.variant_detail?.sold_out
      ) {
        let option2value = variant.option2;
        let option3value = variant.option3;
        setSoldoutOptionValuesArr((prevArr) => [
          ...prevArr,
          option2value,
          option3value,
        ]);
      }
    });
  };
  const handleFirstAvailableOption = (isEdit) => {
    let variantWithInventory;
    if (isEdit) {
      variantWithInventory = SelectedVariant;
    } else {
      variantWithInventory = ProductDetail?.variants?.find(
        (variant) => !variant.variant_detail?.sold_out
      );
    }

    const newActiveSwatches = [...activeSwatches];
    newActiveSwatches[0] = variantWithInventory?.option1;
    newActiveSwatches[1] = variantWithInventory?.option2;
    newActiveSwatches[2] = variantWithInventory?.option3;
    setOption1value(variantWithInventory?.option1);
    setOption2value(variantWithInventory?.option2);
    setOption3value(variantWithInventory?.option3);
    setActiveSwatches(newActiveSwatches);
    setHandleVariantOptions(!handleVariantOptions);
  };
  const handleSoldoutOption = () => {
    const variantWithInventory = ProductDetail?.variants[0];
    const newActiveSwatches = [...activeSwatches];
    newActiveSwatches[0] = variantWithInventory?.option1;
    newActiveSwatches[1] = variantWithInventory?.option2;
    newActiveSwatches[2] = variantWithInventory?.option3;
    setOption1value(variantWithInventory?.option1);
    setOption2value(variantWithInventory?.option2);
    setOption3value(variantWithInventory?.option3);
    setActiveSwatches(newActiveSwatches);
    setHandleVariantOptions(!handleVariantOptions);
  };

  // Single Brand Variants Flow

  const handleSwatch = (index, value) => {
    if (index === 0) {
      setOption1value(value?.trim());
    } else if (index === 1) {
      setOption2value(value?.trim());
    } else if (index === 2) {
      setOption3value(value?.trim());
    }
    const newActiveSwatches = [...activeSwatches];
    newActiveSwatches[index] = value;
    setActiveSwatches(newActiveSwatches);
    setHandleVariantOptions(!handleVariantOptions);
  };

  //? Life Cycles ---------------------------------------------------------------->

  // Single Brand Variant Flow
  useEffect(() => {
    handleOptions();
    handleSoldOutOptionValues();
    // ProductDetail?.is_stitch ? handleAddonSelectedSwatch() : null;
  }, [handleVariantOptions]);

  useEffect(() => {
    let isEdit = typeEdit || false;
    if (ProductDetail?.sold_out) {
      setSoldout(true);
      handleSoldoutOption();
    } else {
      setSoldout(false);
      handleFirstAvailableOption(isEdit);
    }
  }, [ProductDetail]);

  useEffect(() => {
    filterTemplates();
  }, [filterTemplates]);

  useEffect(() => {
    if (!isOutSideProductDetailComponent) {
      let value = { ...SelectedVariant };
      value.option1 = "-9346535324534";
      setSelectedValueFromOptions({ ...value });
    }
  }, []);

  return (
    <Row className="ProductOptions" gutter={[0, 5]}>
      <Col
        span={24}
        className={!isDesktop ? "backgroundLight padding10 paddingBottom0" : ""}
      >
        <Row className="flexBetween">
          {/* <Col span={16}>
            <Text
              className={isDesktop ? " font16 poppinsSemiBold font600" : ""}
              style={{
                color: !isDesktop ? "#010035" : "#010035",
              }}
            >
              {ProductDetail?.options ? ProductDetail?.options[0]?.name : null}
            </Text>
          </Col> */}
          {/* {ProductDetail?.size_chart?.length ? (
            <Col span={8} className="flexEnd">
              <SizeChartDrawer
                ProductDetail={ProductDetail}
                SelectedVariant={SelectedVariant}
                setSelectedVariant={setSelectedVariant}
                SizeChart={ProductDetail?.size_chart}
                availableVariants={availableVariants}
                ProductQuantity={ProductQuantity}
                setProductQuantity={setProductQuantity}
                viewBagItemsState={viewBagItemsState}
                setViewBagItemsState={setViewBagItemsState}
                userAgent={userAgent}
                LineItemAddons={LineItemAddons}
                setLineItemAddons={setLineItemAddons}
                openDrawer={openDrawer}
                setOpenDrawer={setOpenDrawer}
                showDrawersizechart={showDrawer}
                addProduct={addProduct}
                pushedVariants={pushedVariants}
                setPushedVariants={setPushedVariants}
                handleOptionChange={handleOptionChange}
                addToCartLoader={addToCartLoader}
                setaddToCartLoader={setaddToCartLoader}
                selectedValueFromOptions={selectedValueFromOptions}
                setSelectedValueFromOptions={setSelectedValueFromOptions}
                handleProductDiscountedPrice={handleProductDiscountedPrice}
                handleProductOrignalPrice={handleProductOrignalPrice}
                isSizeChartOpen={isSizeChartOpen}
                setIsSizeChartOpen={setIsSizeChartOpen}
              />
            </Col>
          ) : null} */}
        </Row>
      </Col>

      {/* //* Product Options Size, Color etc ---------------------> */}

      {ProductDetail?.options?.length && (
        <div className="swatch-container">
          {ProductDetail.options.map((option, index) => (
            <div
              className={`swatch-product swatch-type-${option.name}`}
              key={index}
            >

              {ProductDetail?.has_variants &&
                !option.values.includes("Default") && (
                  <label className="swatch-label-product">{option.name}:</label>
                )}
              {option.name === "Colorssss" ? (
                <ul className="swatch-item-list swatch-color">
                  {option.values.length > 0
                    ? option.values.split(",").map((value, index1) => (
                      <li
                        key={index1}
                        className={`swatch-element ${activeSwatches[index] === value
                          ? "active"
                          : "uppercase"
                          } ${soldoutOptionValuesArr.includes(value)
                            ? "soldout"
                            : "available"
                          }`}
                        style={{
                          backgroundColor:
                            activeSwatches[index] === value ? mainColor : "",
                        }}
                        data-value={value}
                        onClick={() => handleSwatch(index, value)}
                      >
                        {/* {value} */}
                        <span
                          style={{
                            position: "relative",
                            borderRadius: "50px",
                            border: "1px solid gray",
                            backgroundColor: value
                              ?.toLowerCase()
                              .trim()
                              .replace(/\s+/g, ""),
                          }}
                        >
                          {" "}
                        </span>
                        {activeSwatches[index] === value && (
                          // <img src={NikeTick.src} />
                          <DoneIcon
                            style={{
                              color:
                                value?.toLowerCase() === "white"
                                  ? "black"
                                  : "",
                            }}
                          />
                        )}
                      </li>
                    ))
                    : null}
                </ul>
              ) : ProductDetail?.has_variants &&
                !option.values.includes("Default") ? (
                <ul className="swatch-item-list">
                  {option.values.length > 0
                    ? option.values.split(",").map((value, index1) => (
                      <li
                        key={index1}
                        className={`swatch-element ${activeSwatches[index] === value
                          ? "active"
                          : "uppercase"
                          } ${soldoutOptionValuesArr.includes(value)
                            ? "soldout"
                            : "available"
                          }`}
                        style={{
                          backgroundColor:
                            activeSwatches[index] === value ? mainColor : "",
                        }}
                        data-value={value}
                        onClick={() => handleSwatch(index, value)}
                      >
                        {value}
                      </li>
                    ))
                    : null}
                </ul>
              ) : null}
            </div>
          ))}
        </div>
      )}

      {OtherTempelates?.map((template, index) => {
        return index < 1 ? (
          <Col key={index} span={24} className="padding0">
            <AddonOptions
              template={template}
              userAgent={userAgent}
              ProductDetail={ProductDetail}
              LineItemAddons={LineItemAddons}
              setLineItemAddons={setLineItemAddons}
              setViewBagItemsState={setViewBagItemsState}
              pushedVariants={pushedVariants}
              setPushedVariants={setPushedVariants}
              selectedValueFromOptions={selectedValueFromOptions}
            />
          </Col>
        ) : null;
      })}
    </Row>
  );
}
